import { icons } from '@/helpers/icons.js'

import { FILTERS_BLOCK_1 } from '@/constants'

export const INVENTORY_FILTERS_OPTIONS = [
  'All',
  'Available',
  'Out of Stock',
  'Sold Out',
  'Draft',
]

export const INVENTORY_FILTERS = {
  status_tabs: {
    selected: 'All',
    options: INVENTORY_FILTERS_OPTIONS,
  },
  fast_actions: [
    // {
    //   icon: { is_local: true, value: icons.pencil_square },
    //   name: 'Draft',
    //   key_name: 'with_draft',
    // },
    // {
    //   icon: { is_local: true, value: icons.archive },
    //   name: 'Archived Edits',
    //   key_name: 'with_archived',
    // },
  ],

  filter_blocks: [FILTERS_BLOCK_1],
}

export const INVENTORY_SORT_OPTIONS = [
  {
    label: 'SKU',
    value: 'number',
  },
  {
    label: 'Recently added',
    value: 'created_at.desc',
  },
  {
    label: 'Oldest first',
    value: 'created_at.asc',
  },
  {
    label: 'Last modified',
    value: 'updated_at.desc',
  },
  {
    label: 'Most overpriced',
    value: 'price_ratio.desc',
  },
  {
    label: 'Most underpriced',
    value: 'price_ratio.asc',
  },
  {
    label: 'Status A-Z',
    value: 'status.asc',
  },
  {
    label: 'Status Z-A',
    value: 'status.desc',
  },
  {
    label: 'Sale price high to low',
    value: 'sale_price.desc',
  },
  {
    label: 'Sale price low to high',
    value: 'sale_price.asc',
  },
  {
    label: 'Name A-Z',
    value: 'player.asc',
  },
  {
    label: 'Name Z-A',
    value: 'player.desc',
  },
  {
    label: 'Batch id A-Z',
    value: 'batch_id.asc',
  },
  {
    label: 'Batch id Z-A',
    value: 'batch_id.desc',
  },
]

export const INVENTORY_CARD_COLUMN_OPTIONS = [
  { checked: true, field: 'name', name: 'Product' },
  { checked: true, field: 'sku', name: 'SKU' },
  { checked: true, field: 'inventoryStatus', name: 'Status' },
  { checked: true, field: 'quantity', name: 'On Hand' },
  { checked: true, field: 'availableQuantity', name: 'For Sale' },
  { checked: true, field: 'listings', name: 'Listings' },
  { checked: true, field: 'sale_price', name: 'Sale Price' },
  { checked: true, field: 'sport', name: 'Category' },
  { checked: true, field: 'batch_id', name: 'Batch ID' },
  { checked: true, field: 'year', name: 'Year' },
  { checked: true, field: 'brand', name: 'Brand' },
  { checked: false, field: 'set', name: 'Set' },
  { checked: false, field: 'player', name: 'Name' },
  { checked: false, field: 'card_number', name: 'Card No.' },
  { checked: false, field: 'subset', name: 'Subset/Parallel' },
  { checked: false, field: 'attributes', name: 'Attributes' },
  { checked: false, field: 'team', name: 'Team', eBay: true, shopify: true },
  { checked: false, field: 'variation', name: 'Variation' },
  { checked: false, field: 'graded', name: 'Graded' },
  { checked: false, field: 'grader', name: 'Grader' },
  { checked: false, field: 'condition', name: 'Condition' },
  { checked: false, field: 'cert_no', name: 'Cert No. ' },
  { checked: false, field: 'grade_number', name: 'Grade' },
  { checked: false, field: 'purchase_date', name: 'Purchase Date' },
  { checked: false, field: 'purchase_price', name: 'Purchase Price' },
  { checked: false, field: 'weight_oz', name: 'Weight (oz)' },
  { checked: false, field: 'note', name: 'Note' },
  { checked: false, field: 'cabinet', name: 'Cabinet' },
  { checked: false, field: 'shelf', name: 'Shelf' },
  { checked: false, field: 'box', name: 'Box' },
  { checked: false, field: 'row', name: 'Row' },
  { checked: false, field: 'section', name: 'Section' },
  { checked: true, field: 'actions', name: 'Actions' },
]

export const ICONS_RELATED_TO_STATUS = {
  ready_to_list: 'ready_to_list',
  draft: 'pencil_square',
  available: 'ready_to_list',
  ended: 'stop',
  draft: 'pencil_square',
  sold_out: 'ready_to_list',
  archive: 'archive',
  accepting_offers: 'shopping_cart',
  for_sale: 'shopping_cart',
  sold_on: 'ready_to_list',
  sold: 'ready_to_list',
  out_of_stock: 'ready_to_list',
  active: 'ready_to_list',
  canceled: 'ready_to_list',
  // ended: 'ready_to_list',
  ended_with: 'ready_to_list',
  ended_without: 'ready_to_list',
  inactive: 'ready_to_list',
}

// Unified card-status model (NEW DESIGN) — one source of truth for the shared
// StatusSelect used in the batch grid, inventory grid, and inventory details.
// `variant` maps to a CellDropdownTrigger pill colour; `selectable` = user can
// set it from the dropdown (the rest are system-set, shown read-only).
export const CARD_STATUS_META = {
  draft:         { label: 'Draft',         variant: 'gray',   icon: 'heroicons:pencil-square',  selectable: true },
  // Called "Ready" everywhere in the UI (2026-08-19). The BE value stays
  // `ready_to_list` — only the label shortened.
  ready_to_list: { label: 'Ready',         variant: 'green',  icon: 'pajamas:check-circle',     selectable: true },
  listed:        { label: 'Listed',        variant: 'blue',   icon: 'heroicons:check-badge',    selectable: false },
  out_of_stock:  { label: 'Out of Stock',  variant: 'red',    icon: 'heroicons:arrow-path',     selectable: false },
  sold_out:      { label: 'Sold Out',      variant: 'yellow', icon: 'heroicons:x-circle',       selectable: false },
}
export const SELECTABLE_CARD_STATUSES = ['draft', 'ready_to_list']

// export const INVENTORY_STATUSES = ['available', 'for_sale', 'ended', 'draft', 'sold_out', 'archive']
export const INVENTORY_STATUSES = [
  'available',
  'ended',
  'draft',
  'sold_out',
  'sold',
]

export const INVENTORY_STATUS = {
  accepting_offers: {
    key: 'accepting_offers',
    label: 'Accepting Offers',
    icon: 'heroicons:hand-money',
  },
  for_sale: {
    key: 'for_sale',
    label: 'For Sale',
    icon: 'heroicons:tag',
  },
  sold_out: {
    key: 'sold_out',
    label: 'Sold Out',
    icon: 'heroicons:tag',
  },
  sold_on: {
    key: 'sold_on',
    label: 'Sold On',
    icon: 'heroicons:tag',
  },
  ended: {
    key: 'ended',
    label: 'Ended',
    icon: 'heroicons:tag',
  },
}

export const DATABASE_MATCH_FIELDS_FOR_VIEW = [
  {
    field: 'database_match',
    label: 'Database Match',
    type: 'text',
  },
  {
    field: 'year',
    label: 'Year',
    type: 'number',
  },
  {
    field: 'brand',
    label: 'Brand',
    type: 'text',
  },
  {
    field: 'set',
    label: 'Set',
    type: 'text',
  },
  {
    field: 'card_number',
    label: 'Card No.',
    type: 'number',
  },
  {
    field: 'player',
    label: 'Name',
    type: 'text',
  },
  {
    field: 'subset',
    label: 'Subset / Parallel',
    type: 'text',
  },
  {
    field: 'variation',
    label: 'Variation',
    type: 'text',
  },
  {
    field: 'team',
    label: 'Team',
    type: 'text',
  },
]

export const LOCATIONS_FIELDS = [
  {
    label: 'Cabinet',
    field: 'cabinet',
  },
  {
    label: 'Shelf',
    field: 'shelf',
  },
  {
    label: 'Box',
    field: 'box',
  },
  {
    label: 'Row',
    field: 'row',
  },
  {
    label: 'Section',
    field: 'section',
  },
]

export const ATTRIBUTES = {
  sports: ['Rookie', 'Autographed', 'Memorabilia'],
  pokémon: [
    'Amazing Rare',
    'Classic Collection',
    'Code Card',
    'Common',
    'Holo Rare',
    'Prism Rare',
    'Promo',
    'Rare',
    'Rare Ace',
    'Rare BREAK',
    'Secret Rare',
    'Shiny Holo Rare',
    'Ultra Rare',
    'Uncommon',
  ],
  'magic: the gathering': [
    'Common',
    'Land',
    'Mythic',
    'Promo',
    'Rare',
    'Special',
    'Token',
    'Uncommon',
  ],
  'yu-gi-oh': [
    '10000 Secret Rare',
    'Collector’s Rare',
    'Common / Short Print',
    'Duel Terminal Technology Common',
    'Duel Terminal Technology Ultra Rare’',
    'Ghost Rare',
    'Gold Rare',
    'Gold Secret Rare',
    'Mosaic Rare',
    'Premium Gold Rare',
    'Promo',
    'Rare',
    'Secret Pharaoh’s Rare',
    'Secret Rare’',
    'Shatterfoil Rare',
    'Starfoil Rare',
    'Starlight Rare',
    'Super Rare',
    'Ultimate Rare',
    'Ultra Pharaoh’s Rare',
    'Ultra Rare',
  ],
  'non-sport': ['Autographed', 'Memorabilia'],
}

export const QUANTITY_TYPES = [
  {
    label: 'Multiple Items',
    value: 'multiple',
  },
  {
    label: 'Single Item',
    value: 'single',
  },
]

// CDP-2456 — Inventory CSV import. Endpoints, limits, and file constraints for
// the "Import from CSV" flow. Backend is already live (see the ticket).
export const INVENTORY_CSV_IMPORT = Object.freeze({
  ACCEPT: '.csv',
  MAX_SIZE_MB: 50,
  MAX_ROWS: 5000,
  ENTITLEMENT: 'csv-inventory-import', // Allstar+; 403 → upgrade messaging
  // Upload is async: the POST only queues the job. We learn the outcome
  // (created/failed/errors) once the job finishes — surfaced via Pusher
  // `job_updated` under this key, confirmed with GET /jobs/id/{jobId}.
  JOB_TYPE: 'import-csv-inventory',
  TEMPLATE_FILENAME: 'cdp-inventory-import-template.csv',
  ERRORS_FILENAME: 'cdp-inventory-import-errors.csv',
  ENDPOINTS: {
    TEMPLATE: '/inventory/csv-import/template',
    UPLOAD: (inventoryId) => `/inventory/${inventoryId}/csv-import`,
    ERRORS: (jobId) => `/inventory/csv-import/jobs/${jobId}/errors`,
    JOB: (jobId) => `/jobs/id/${jobId}`,
  },
})

export const IMPORT_INVENTORY_DIALOG_DATA = {
  confirmationMessage:
    'This action will import all your active listings. Expect this to take a few minutes. We\’ll email you when your import is complete.',
  confirmButtonText: 'Start Import',
  confirmLabel: 'Import listings from',
  singleOkButton: false,
  warningIcon: false,
  content: null,
  logo: null,
}
